import { PORTAL_AUTH_CLIENT, getPortalAccessQrToken, getPortalAccessToken } from '@/core/auth/portal-storage'
import { getAccessToken } from '@/core/auth/storage'

/** Staff recruitment-portal routes (`/recruitment-portal/*`), excluding guest QR `/r/:token`. */
export function isRecruitmentPortalPath(pathname = window.location.pathname): boolean {
  return pathname === '/recruitment-portal' || pathname.startsWith('/recruitment-portal/')
}

export function isRecruitmentPortalLoginPath(pathname = window.location.pathname): boolean {
  return pathname === '/recruitment-portal/login' || pathname.startsWith('/recruitment-portal/login/')
}

/** Authenticated portal app surface — not the portal login page. */
export function isRecruitmentPortalAppPath(pathname = window.location.pathname): boolean {
  return isRecruitmentPortalPath(pathname) && !isRecruitmentPortalLoginPath(pathname)
}

/**
 * Portal PAT when there is no CRM session, or when a scanned access QR is bound
 * (that QR’s onsite/recruitment login must not be hijacked by another CRM role).
 */
export function usesPortalAuthClient(pathname = window.location.pathname): boolean {
  if (!isRecruitmentPortalAppPath(pathname) || !getPortalAccessToken()) return false
  if (!getAccessToken()) return true
  return Boolean(getPortalAccessQrToken())
}

export function activeAuthClient(
  pathname = window.location.pathname,
): 'crm' | typeof PORTAL_AUTH_CLIENT {
  return usesPortalAuthClient(pathname) ? PORTAL_AUTH_CLIENT : 'crm'
}

export function getActiveAccessToken(pathname = window.location.pathname): string | null {
  return usesPortalAuthClient(pathname) ? getPortalAccessToken() : getAccessToken()
}

export function authClientHeaders(
  pathname = window.location.pathname,
): Record<string, string> {
  if (!usesPortalAuthClient(pathname)) return {}
  return {
    'X-Auth-Client': PORTAL_AUTH_CLIENT,
  }
}

